/**
 * When publishing or subscring to events - use the prepared event names below
 */
export const EVENT = {
  /**
   * Event for modifying browser history
   */
  HISTORY_ACTION: "HISTORY_ACTION",
  /**
   * Track event in GTM or similar
   */
  TRACK_EVENT: "TRACK_EVENT",
};

export type TEvent = keyof typeof EVENT;
